export default {
  styleOverrides: {
    root: ({}) => {
      return {
      }
    }
  }
}
